import { ErrorHandler } from '@angular/core';
import { ErrorStateMatcher } from '@angular/material/core';

import { GlobalErrorStateMatcher } from '@shared/matchers/error-state.matcher';
import { IsCustomGroupPipe } from '@shared/pipes/is-custom-group.pipe';
import { IsNullOrWhiteSpacePipe } from '@shared/pipes/is-null-or-white-space.pipe';
import { AppInitializerService } from '@shared/services/app-initializer.service';
import { ApplicationInsightsService } from '@shared/services/application-insights.service';
import { AttributeAssignmentFiltersService } from '@shared/services/attribute-assignment-filters.service';
import { ClarityService } from '@shared/services/clarity.service';
import { GlobalErrorHandlerService } from '@shared/services/global-error-handler.service';
import { RouterService } from '@shared/services/router.service';
import { SeoService } from '@shared/services/seo.service';
import { UuidService } from '@shared/services/uuid.service';

export const APP_PROVIDERS = [
  { provide: ErrorStateMatcher, useClass: GlobalErrorStateMatcher },
  { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
  ApplicationInsightsService,
  AppInitializerService,
  AttributeAssignmentFiltersService,
  ClarityService,
  RouterService,
  SeoService,
  UuidService,

  IsCustomGroupPipe,
  IsNullOrWhiteSpacePipe
];
